export const en = {
  help: `what's this mean?`,
  urlRequiredMessage: 'Website URL cannot be empty.'
};

export type Translations = typeof en;
